import { iCateNode, SET_CATE_TREE } from "./type";

const _initState = {
    cateTree: [] as iCateNode[]
}

const cateTreeStore = (state = _initState, action: any) => {
    switch (action.type) {
        case SET_CATE_TREE:
            return {
                ...state,
                cateTree: action.payload
            };
        default:
            return state;
    }
};

export {
    cateTreeStore
};